import Vue from 'vue';
import ToggleSliderInput from 'src/components/forms/ToggleSliderInput.vue';
/**
  Renders a toggle slider.

  Example usage from a parent component:

     <div class="field">
         <toggle-slider v-model="sentimentEnabled">
             Enable Sentiment Identification
         </toggle-slider>
     </div>

 */
export default Vue.extend({
    components: { ToggleSliderInput },
    props: {
        value: Boolean,
        disabled: Boolean,
        label: { type: String, default: '' },
    }
});
